import React from "react";
import StarIcon from "./StarIcon";
import * as S from "./styles";
export var StarReviews = function StarReviews(_ref) {
  var e = _ref.numOfReviews,
      _ref$showNumOfReviews = _ref.showNumOfReviews,
      t = _ref$showNumOfReviews === void 0 ? !0 : _ref$showNumOfReviews,
      a = _ref.rating,
      n = _ref.className;
  var l = a / 5 * 100,
      c = 10 * Math.round(l / 10) + "%";
  return React.createElement(S.StarContainer, {
    "data-testid": "starReviews",
    className: n
  }, React.createElement(S.EmptyStars, null, React.createElement(StarIcon, null), React.createElement(StarIcon, null), React.createElement(StarIcon, null), React.createElement(StarIcon, null), React.createElement(StarIcon, null), React.createElement(S.FilledStars, {
    rating: c
  }, React.createElement(StarIcon, null), React.createElement(StarIcon, null), React.createElement(StarIcon, null), React.createElement(StarIcon, null), React.createElement(StarIcon, null))), t && e ? React.createElement(S.ReviewCount, null, e, React.createElement(S.HiddenText, null, " Reviews")) : null);
};
export default StarReviews;